import React, { useState } from "react";
import { Box, Typography, Grid, Tab, Tabs } from "@mui/material";
import WaiverDefination from "./waiver-defination";
import WaiverDefinationHistory from "./waiver-defination-history";
const WaiverDetails = () => {
  const [value, setValue] = useState(0);
  const handleChange = (event, newValue) => {
    setValue(newValue);
  };

  function TabPanel(props) {
    const { children, value, index, ...other } = props;
    return (
      <div hidden={value !== index} {...other}>
        {value === index && (
          <Box>
            <Typography>{children}</Typography>
          </Box>
        )}
      </div>
    );
  }
  return (
    <div className="main-person-container">
      <div className="subs-mainTabContainer">
        <Box
          sx={{ borderBottom: 1, borderColor: "divider" }}
          className="subs-tab-container"
        >
          <Grid container spacing={0}>
            <Grid item md={12} xs={12} sm={7} className="custom-tabs">
              <Tabs
                value={value}
                onChange={handleChange}
                scrollButtons
                variant="scrollable"
                allowScrollButtonsMobile
              >
                <Tab label="Waiver Defination" />
                <Tab label="Waiver Defination History" />
              </Tabs>
            </Grid>
          </Grid>
        </Box>
      </div>
      <div className="tab-panel-container">
        <TabPanel value={value} index={0}>
          <WaiverDefination />
        </TabPanel>
        <TabPanel value={value} index={1}>
          <WaiverDefinationHistory />
        </TabPanel>
      </div>
    </div>
  );
};

export default WaiverDetails;
